import type { OilPhaseVolumeFactorBoCalculator } from "../../d";

export const oilPhaseVolumeFactorBoCalculator: OilPhaseVolumeFactorBoCalculator =
  params => {
    const {
      gasSpecificGravity,
      temperatureF,
      inSituPressurePSIA,
      gasOilRatio,
      oilSpecificGravity,
      bubblePointPressurePSIA,
      solutionGasRsoInSitu,
      oilAPI,
      x
    } = params;

    // D104: =(((J18/112727)+12.34)*(D8^0.8439)*10^D90)^1.73184
    let solutionGasPbRsb =
      ((bubblePointPressurePSIA / 112727 + 12.34) *
        gasSpecificGravity ** 0.8439 *
        10 ** x) **
      1.73184;

    solutionGasPbRsb =
      solutionGasPbRsb > gasOilRatio ? gasOilRatio : solutionGasPbRsb;

    // D108: =(1.705*10^-7)*(D104^0.69357)*(D8^0.1885)*(D7^0.3272)*(D4^0.6729)*(D3^-0.5906)
    const oilCompressibilityUnSatCo =
      1.705 *
      10 ** -7 *
      solutionGasPbRsb ** 0.69357 *
      gasSpecificGravity ** 0.1885 *
      oilAPI ** 0.3272 *
      temperatureF ** 0.6729 *
      inSituPressurePSIA ** -0.5906;

    // D110: =IF(D108<2.464*10^-5,2.464*10^-5,IF(D108>3.507*10^-5,3.507*10^-5,D108))
    // THIS CODE APPLIES AN UPPER AND LOWER LIMIT TO THE oilCompressibilityUnSatCo VARIABLE
    // IF oilCompressibilityUnSatCo IS WITHIN LIMITS, IT WILL BE THE VALUE
    let oilCompressibilityLimitedUnSatCo = oilCompressibilityUnSatCo;
    const lowerLimit = 2.464 * 10 ** -5;
    const upperLimit = 3.507 * 10 ** -5;
    if (oilCompressibilityUnSatCo < lowerLimit) {
      oilCompressibilityLimitedUnSatCo = lowerLimit;
    }
    if (oilCompressibilityUnSatCo > upperLimit) {
      oilCompressibilityLimitedUnSatCo = upperLimit;
    }

    // D106: =1.0113+(7.2046*10^-5)*((D104^0.3738)*((D8^0.2914)/(D17^0.6265))+0.24626*(D4^0.5371))^3.0936
    const oilFormationVolumeFactoratPbBob =
      1.0113 +
      7.2046 *
        10 ** -5 *
        (solutionGasPbRsb ** 0.3738 *
          (gasSpecificGravity ** 0.2914 / oilSpecificGravity ** 0.6265) +
          0.24626 * temperatureF ** 0.5371) **
          3.0936;

    // D112: =D106*EXP(D110*(J18-D3))
    const oilFormationVolumeFactorUnSatBo =
      oilFormationVolumeFactoratPbBob *
      Math.exp(
        oilCompressibilityLimitedUnSatCo *
          (bubblePointPressurePSIA - inSituPressurePSIA)
      );
    // D102: =1.0113+(7.2046*10^-5)*((J12^0.3738)*((D8^0.2914)/(D17^0.6265))+0.24626*(D4^0.5371))^3.0936
    const oilFormationVolumeFactorSatBo =
      1.0113 +
      7.2046 *
        0.00001 *
        (solutionGasRsoInSitu ** 0.3738 *
          (gasSpecificGravity ** 0.2914 / oilSpecificGravity ** 0.6265) +
          0.24626 * temperatureF ** 0.5371) **
          3.0936;
    return {
      solutionGasPbRsb,
      oilFormationVolumeFactoratPbBob,
      oilCompressibilityUnSatCo,
      oilCompressibilityLimitedUnSatCo,
      oilFormationVolumeFactorSatBo,
      oilFormationVolumeFactorUnSatBo
    };
  };
